import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import BoxRoot from '@/legacy/components/ui/Box/primitives/BoxRoot';
import { DEVICES_CATALOG } from '../domain/catalog';
import { paths } from '@/app/router/path';
import CatalogCta from './CatalogCta';
import DeviceThumbnail from './DeviceThumbnail';

const deviceCount = Object.keys(DEVICES_CATALOG).length;

const DevicesCatalogCard = () => {
	const { t } = useTranslation('marketplace');
	const navigate = useNavigate();

	return (
		<BoxRoot
			clickable
			onClick={() => navigate(paths.marketplace.tabs('devices'))}
			className='bg-highlight-gradient medium-card-padding justify-start gap-2'
			style={{ borderColor: 'var(--color-border-cuaternary)' }}
		>
			<div className='absolute top-5 right-4'>
				<DeviceThumbnail />
			</div>
			<h3 className='text-xs text-tertiary uppercase'>{t('tabs.devices')}</h3>
			<p className='text-2xl font-medium text-primary pr-20 line-clamp-2'>
				{t('devicesCatalog.title')}
			</p>
			<CatalogCta
				label={t('devicesCatalog.promoCard.cta', {
					count: deviceCount,
				})}
			/>
		</BoxRoot>
	);
};

export default DevicesCatalogCard;
